import './AppHeader.css';
export var header = '_18p1krr0-2-0-1';